import ManageDataModelDrawer from "./DataModelsDrawers/ManageDataModelDrawer";
import ManageCollectionDrawer from "./DataModelsDrawers/ManageCollectionDrawer";
import { DRAWERS } from "./drawers.constants";
import ManageEndpointDrawer from "./DataModelsDrawers/ManageEndpointDrawer";
import ManagePropertyDrawer from "./DataModelsDrawers/ManagePropertyDrawer";
import ManageBackgroundTaskDrawer from "./DataModelsDrawers/ManageBackgroundTaskDrawer";
import ManageRecordDrawer from "./DataModelsDrawers/ManageRecordDrawer";
import CreateIntegrationDrawer from "./MulesoftDrawers/CreateIntegrationDrawer";
import DeploymentLogsDrawer from "./DataModelsDrawers/DeploymentLogsDrawer";
import ManageOrganizationDrawer from "./DataModelsDrawers/ManageOrganizationDrawer";
import ManageAppDrawer from "./ApplicationDrawers/ManageAppDrawer";

const {
  MANAGE_DATA_MODEL_DRAWER,
  MANAGE_COLLECTION_DRAWER,
  MANAGE_PROPERTY_DRAWER,
  MANAGE_ENDPOINT_DRAWER,
  MANAGE_RECORD_DRAWER,
  MANAGE_BACKGROUND_TASK_DRAWER,
  CREATE_INTEGRATION_DRAWER,
  DEPLOYMENT_LOGS_DRAWER,
  MANAGE_ORGANIZATION_DRAWER,
  MANAGE_APP_DRAWER,
} = DRAWERS;

const renderDrawer = (name) => ({
    [MANAGE_DATA_MODEL_DRAWER]: <ManageDataModelDrawer />,
    [MANAGE_COLLECTION_DRAWER]: <ManageCollectionDrawer />,
    [MANAGE_PROPERTY_DRAWER]: <ManagePropertyDrawer />,
    [MANAGE_RECORD_DRAWER]: <ManageRecordDrawer />,
    [MANAGE_BACKGROUND_TASK_DRAWER]: <ManageBackgroundTaskDrawer />,
    [DEPLOYMENT_LOGS_DRAWER]: <DeploymentLogsDrawer />,
    [MANAGE_ENDPOINT_DRAWER]: <ManageEndpointDrawer />,
    [CREATE_INTEGRATION_DRAWER]: <CreateIntegrationDrawer />,
    [MANAGE_ORGANIZATION_DRAWER]: <ManageOrganizationDrawer />,
    [MANAGE_APP_DRAWER]: <ManageAppDrawer />,
  }[name] || null);

export default renderDrawer;
